var React = require('react');

function CtaShape (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a914b63c-62bf-4b33-8641-67638ce754c0 {\n        fill: #f13e2f;\n      }\n    ")),React.createElement("path",{"id":"bb8e8f23-9ba1-4c4d-a70c-a8d47132c0c8","data-name":"Path 656","className":"a914b63c-62bf-4b33-8641-67638ce754c0","d":"M0,0,60.98486,60.985V255.127H0Z","key":1})]);
}

CtaShape.defaultProps = {"id":"fe2f5dc7-e952-423f-98be-bcf64c1880d0","data-name":"Layer 1","viewBox":"0 0 60.98486 255.12701"};

module.exports = CtaShape;

CtaShape.default = CtaShape;
